import { render, staticRenderFns } from "./Allmessages.vue?vue&type=template&id=24d8896e"
import script from "./Allmessages.vue?vue&type=script&lang=js"
export * from "./Allmessages.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./Allmessages.vue?vue&type=style&index=1&id=24d8896e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports